import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ["signedIdInput"]

  connect() {
    document.addEventListener("direct-upload:end", this.handleDirectUploadEnd)
  }

  disconnect() {
    document.removeEventListener("direct-upload:end", this.handleDirectUploadEnd)
  }

  handleDirectUploadEnd = (event) => {
    console.log("Direct upload event received", event);
    const { attachment } = event.detail;
    
    if (attachment) {
      const signedId = attachment.signed_id;
      if (this.hasSignedIdInputTarget) {
        this.signedIdInputTarget.value = signedId;
      }
    } else {
      console.error("Attachment not found in event detail:", event);
    }
  }
}
